import styled from "styled-components";
import blogbackground from "../assets/blogbackground.jpeg";

export default styled.div`

  #b2b{
      text-decoration: none;
      position: relative;
      right: 0;
      min-width: 120px;
      max-width: 166px;
      display: inline-block;
      border: 1px solid white;
      border-radius: 5px;
      color: white;
      padding: 0.5em 0.5em;
      text-align: center;
      z-index: 2;
      margin: 1em;

      &:hover{
        color: #009944;
        background: white;
        transition: 300ms;
      }
  }

.black{
  color: #222829 !important;
}

img{
  width: 100%;
  object-fit: contain;
}

.top{
  margin-top: 3em;
}

.image{
 width: 100%;
 object-fit: cover;
 height: 600px;
 object-position: top;
}


#post-title{
 margin-top: 1em ;
}

.header{

  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  align-items: flex-start;
  justify-content: center;
  padding: 1.75em;
  height: 500px;

  &::after{
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: 100%;
    width: 100%;
    background: rgba(0,0,0,0.5);
    z-index: 1;
  }

  img{
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
  }

  .in-header-content{

    padding: 1em 0;
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;

    h3{
      margin: 0;
      font-weight: 1000;
      font-size: 26px;
      text-transform: uppercase;
      text-align: left;
      font-style: italic;
    }

    p{
      font-weight: 600;
      font-size: 50px;
    }

    h3,p,span {
      color: white;
      line-height: 35px;
      margin-left: 20px !important;
    }

    span{
        font-weight: bolder;
    }

  }

}

  .withBackground {

    position: relative;
    background: url(${blogbackground});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top;

    @media(min-width: 2000px){
      background-position: 0 -20em;
    }

    height: 300px;

    h3{
      position: relative:
      z-index:1;
      font-weight: 600;
      line-height: normal;
      letter-spacing: 1px;
      font-size: 32px;
      color: #FFFFFF;
    }

    &::before {
      content: "";
      position: absolute;
      background: rgba(0, 148, 68, 0.25);
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      height: 100%;
      width: 100%;
    }

  }

  a {
    padding: 1em;
    width: 100%;
    display: inline-block;

    &.active {
      color: #009444;
    }

    color: #8795a1;
    text-decoration: none;

  }


  .content{

   h3{
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      font-size: 24px;
      color: #009444;
   }

   p,span{
      font-weight: 300;
      line-height: 27px;
      font-size: 18px;
      color: #3D4851;
      margin: 0.5em 0;
   }

}

  .lifted{
    position: relative;
    top: -70px;
    background: white;
    padding: 3em;
    z-index: 1;
  }

  @media(max-width: 768px){

    .lifted{
      top: 0;
      padding: 1em;
    }

    .header{
      padding: 0;
      height: 350px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
    }

    p, li, span{
      font-size: 14.5px !important;
      line-height: 30px !important;
    }

    .header h3{
      font-size: 21px;
    }

    .header h3, .header p, .header span{
      margin-left: 1em !important;
      display: inline-block;
    }

    .header p{
      font-size: 1.5em !important;
      line-height: 1.7em !important;
      letter-spacing: 0.75px;
      font-weight: 600;
    }

    .impact{
      padding: 0em 1em !important;
      .inner{
        padding: 3em 0 !important;
      }
    }

    .impact img{
      height: 140px;
    }

    .impact p{
      text-align: left;
    }

    #just-more-logos {
      padding: 1em 2em;
    }

    .impact .box{
      text-align: left;

      img{
        width: auto;
      }
    }

  }
`;



// WEBPACK FOOTER //
// /opt/build/repo/src/styles/post.style.js